<div class="widget-tech-group-card card h-100">
  <img class="mw-100" [src]="imageUrl" />
  @if (description != undefined) {
    <div class="header p-2">{{ description }}</div>
  }
  @if (techGroupNumber != undefined) {
    <app-link [url]="'/tech-group/' + techGroupNumber" classes="stretched-link"></app-link>
  }
</div>
